import { gql } from 'graphql-request'

export const GET_LIVE_DETAILS_PEOPLE = gql`
  query GET_LIVE_DETAILS_PEOPLES($liveId: Int!) {
    getLivesDetailsPeoplesByLiveId(liveId: $liveId) {
      status
      error
      data {
        id
        createdAt
        liveId
        updatedAt
        userId
        chatMuted
        canJoinSeat
        kicked
        inLive
        points
      }
    }
  }
`

export const GET_LIVE_DETAIL_PEOPLE = gql`
  query GET_LIVE_DETAIL_PEOPLE($liveDetailPeopleId: Int!) {
    getLiveDetailPeople(liveDetailPeopleId: $liveDetailPeopleId) {
      status
      error
      data {
        id
        createdAt
        liveId
        updatedAt
        userId
        chatMuted
        canJoinSeat
        kicked
        points
        inLive
      }
    }
  }
`

export const GET_LIVE_DETAIL_PEOPLE_BY_USER_ID = gql`
  query GET_LIVE_DETAIL_PEOPLE_BY_USER_ID($userId: Int, $liveId: Int) {
    getLiveDetailPeopleFirst(userId: $userId, liveId: $liveId) {
      status
      error
      data {
        id
        createdAt
        liveId
        updatedAt
        userId
        chatMuted
        canJoinSeat
        kicked
        points
        inLive
      }
    }
  }
`

export const UPDATE_LIVE_DETAIL_PEOPLE = gql`
  mutation UPDATE_LIVE_DETAIL_PEOPLE(
    $liveDetailPeopleId: Int!
    $liveId: Int!
    $chatMuted: Boolean
    $canJoinSeat: Boolean
    $kicked: Boolean
    $inLive: Boolean
  ) {
    updateLiveDetailPeople(
      liveDetailPeopleId: $liveDetailPeopleId
      liveId: $liveId
      chatMuted: $chatMuted
      canJoinSeat: $canJoinSeat
      kicked: $kicked
      inLive: $inLive
    ) {
      status
      error
      data {
        id
        createdAt
        liveId
        updatedAt
        userId
        chatMuted
        canJoinSeat
        kicked
        inLive
      }
    }
  }
`

export const CREATE_LIVE_DETAIL_PEOPLE = gql`
  mutation CREATE_LIVE_DETAIL_PEOPLE($liveId: Int!) {
    createLiveDetailPeople(liveId: $liveId) {
      status
      error
      data {
        id
        createdAt
        liveId
        updatedAt
        userId
        chatMuted
        canJoinSeat
        kicked
        inLive
      }
    }
  }
`

export const DELETE_LIVE_DETAIL_PEOPLE_POINTS = gql`
  mutation DELETE_LIVE_DETAIL_PEOPLE_POINTS(
    $liveDetailPeopleId: Int!
    $liveId: Int!
  ) {
    deleteLiveDetailPeoplePoints(
      liveDetailPeopleId: $liveDetailPeopleId
      liveId: $liveId
    ) {
      data {
        id
        canJoinSeat
        chatMuted
        createdAt
        inLive
        kicked
        liveId
        points
        updatedAt
        userId
      }
    }
  }
`
